export default "__VITE_ASSET__gawvnK4j__"